<template>
  <el-dialog
    :visible.sync="visible"
    :close-on-click-modal="false"
    :before-close="handleClose"
    @open="handleOpen"
    title="下载列表"
    class="finance-dialog"
  >
    <div class="dialog-body">
      <div>
        <jr-table
          ref="tableRef"
          :height="300"
          :tableData="downloadListData.list"
          :tableColumn="tableColumn"
          :pagination="true"
          :total="downloadListData.total"
          :search-params.sync="downloadParams"
          @refresh="refreshList"
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import { downloadFiles } from '@/utils/file-download';
import { getDataExportResult } from '@/api/global';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableColumn: [
        { prop: 'tempName', label: '任务', minWidth: '1' },
        { prop: 'fileName', label: '文件名', minWidth: '1', showOverflowTooltip: true },
        { prop: 'statusDesc', label: '进度', minWidth: '1' },
        { prop: 'createTime', label: '导出时间', minWidth: '1', filterName: 'formatTime' },
        { prop: 'finishTime', label: '完成时间', minWidth: '1', filterName: 'formatTime' },
        {
          label: '操作',
          width: '120',
          prop: 'operate',
          btnGroups: [
            {
              name: '下载',
              className: ['table-button', 'table-button-primary'],
              showBtn: (row) => row.status === 'SUCCESS',
              click: (row) => this.handleDownload(row),
            },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapGetters('global', [
      'downloadParams',
      'downloadListData',
    ]),
  },
  methods: {
    // 关闭
    handleClose() {
      this.$emit('update:visible', false);
    },
    // 打开窗口前
    handleOpen() {
      this.$nextTick(() => {
        this.$store.commit('global/SET_DOWNLOAD_TEXT', '');
        this.$refs.tableRef.doLayout();
      });
    },
    async handleDownload(row) {
      try {
        const res = await getDataExportResult({ taskId: row.taskId }, row.templateCode);
        if (res?.data?.status === 'SUCCESS') {
          downloadFiles(res.data.fileUrl, res.data.fileName);
          this.$message.success('下载成功！');
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 刷新列表
    refreshList(params) {
      this.$store.commit('global/SET_DOWNLOAD_PARAMS', params);
      this.$store.dispatch('global/getDownloadList');
    },
  },
};
</script>
